export default __webpack_public_path__ + "static/media/reserva.578d27d5.png";